import { ReactElement } from 'react';
import { Button } from '@appsumo/dorado-react';

import { Loader } from '~/components/ui';

export default function Summary({
  isLoading,
  isDisabled,
  onClick,
}: {
  isLoading: boolean;
  isDisabled: boolean;
  onClick: () => void;
}): ReactElement {
  return (
    <Button
      className="hidden w-full text-center md:block"
      data-testid="summary-cart-button"
      onClick={onClick}
      disabled={isDisabled || isLoading}
    >
      <div className="flex w-full items-center justify-center">
        Proceed to checkout
        {isLoading && (
          <span className="ml-2">
            <Loader size="sm" />
          </span>
        )}
      </div>
    </Button>
  );
}
